import type { RouteLocationRaw } from 'vue-router';

import { companyDetailsParam, type CompanyRouteRef } from './company-route';

/** Minimal note identity for building /companies/:id/notes/:noteId links. */
export type CompanyNoteRouteRef = { number: number; id?: string } | { id: string; number?: number };

/** Public segment for /companies/:id/notes/:noteId — numeric id when present, else legacy UUID. */
export function companyNoteDetailsParam(note: CompanyNoteRouteRef): string {
  if ('number' in note && note.number !== undefined && note.number !== null) {
    return String(note.number);
  }
  if ('id' in note && note.id) return note.id;
  throw new Error('Company note route ref must include number or id');
}

/** Build a company-note-details route using the public numeric id. */
export function companyNoteDetailsTo(
  company: CompanyRouteRef,
  note: CompanyNoteRouteRef,
): RouteLocationRaw {
  return {
    name: 'company-note-details',
    params: { id: companyDetailsParam(company), noteId: companyNoteDetailsParam(note) },
  };
}
